<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
.scrollbar-wrap .scrollbar-y {
  background: #c2c2c2 !important;
}
</style>